import React from 'react'
import { useGlobalState } from 'state'
import { IDs } from 'common/consts'
import mapboxgl from 'mapbox-gl'

export const CenterLineLayer = () => {
  const state = useGlobalState()
  const layerId = IDs.centerLine

  React.useEffect(() => {
    if (!state.mapbox) return
    if (!state.map.hasLayer(layerId)) {
      state.map.addLayer({
        id: layerId,
        type: 'line',
        source: {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: []
          }
        },
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        paint: {
          'line-color': '#cccccc',
          'line-width': 2
        }
      })
    }
    refresLayerData()
    state.mapbox.on('move', refresLayerData)

    return () => {
      if (!state.mapbox) return
      state.mapbox.off('move', refresLayerData)
    }
  }, [state.mapbox])

  const refresLayerData = () => {
    if (!state.mapbox) return
    const mapSource = state.mapbox.getSource(layerId) as mapboxgl.GeoJSONSource
    if (!mapSource) return

    const bounds = state.mapbox.getBounds()
    const center = state.mapbox.getCenter()
    const features: GeoJSON.Feature[] = [
      {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [
            [bounds.getWest(), center.lat],
            [bounds.getEast(), center.lat]
          ]
        },
        properties: null
      },
      {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [
            [center.lng, bounds.getNorth()],
            [center.lng, bounds.getSouth()]
          ]
        },
        properties: null
      },
    ]
    mapSource.setData({
      type: 'FeatureCollection',
      features: features
    })
  }

  return <></>
}
